import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';

const MODULE_PREFIX = '[HELP]';

// Actions
const Actions = {
  fetchCategories: `${MODULE_PREFIX} fetchCategories`,
  setCategories: `${MODULE_PREFIX} setCategories`,
  fetchSubCategories: `${MODULE_PREFIX} fetchSubCategories`,
  setSubCategories: `${MODULE_PREFIX} setSubCategories`,
  fetchFaq: `${MODULE_PREFIX} fetchFaq`,
  setFaq: `${MODULE_PREFIX} setFaq`,
  fetchFaqAnswers: `${MODULE_PREFIX} fetchFaqAnswers`,
  setFaqAnswers: `${MODULE_PREFIX} setFaqAnswers`,
  resetFaqAnswers: `${MODULE_PREFIX} resetFaqAnswers`,
  fetchTickets: `${MODULE_PREFIX} fetchTickets`,
  setOpenTickets: `${MODULE_PREFIX} setOpenTickets`,
  setClosedTickets: `${MODULE_PREFIX} setClosedTickets`,
  resetTickets: `${MODULE_PREFIX} resetTickets`,
  getSelectedTab: `${MODULE_PREFIX} getSelectedTab`,
  setSelectedTab: `${MODULE_PREFIX} setSelectedTab`,
  getViewMoreFlag: `${MODULE_PREFIX} getViewMoreFlag`,
  setViewMoreFlag: `${MODULE_PREFIX} setViewMoreFlag`,
};

export const fetchCategories = createAction(Actions.fetchCategories);
export const setCategories = createAction(Actions.setCategories);
export const fetchSubCategories = createAction(Actions.fetchSubCategories);
export const setSubCategories = createAction(Actions.setSubCategories);
export const fetchFaq = createAction(Actions.fetchFaq);
export const setFaq = createAction(Actions.setFaq);
export const fetchFaqAnswers = createAction(Actions.fetchFaqAnswers);
export const setFaqAnswers = createAction(Actions.setFaqAnswers);
export const resetFaqAnswers = createAction(Actions.resetFaqAnswers);
export const fetchTickets = createAction(Actions.fetchTickets);
export const setOpenTickets = createAction(Actions.setOpenTickets);
export const setClosedTickets = createAction(Actions.setClosedTickets);
export const getSelectedTab = createAction(Actions.getSelectedTab);
export const setSelectedTab = createAction(Actions.setSelectedTab);
export const resetTickets = createAction(Actions.resetTickets);
export const getViewMoreFlag = createAction(Actions.getViewMoreFlag);
export const setViewMoreFlag = createAction(Actions.setViewMoreFlag);

export const getSelectedTabIndex = (state) => {
  return get(state, 'helpAndSupport.selectedTab', 0);
};

export const getCategoriesData = (state) => {
  return get(state, 'helpAndSupport.categories.categories', []);
};
export const getCustomerCareNumber = (state) => {
  return get(state, 'helpAndSupport.categories.customer_care_no', '');
};
export const getSubcategoriesData = (state) => {
  return get(state, 'helpAndSupport.subCategories', []);
};
export const getFaqList = (state) => {
  return get(state, 'helpAndSupport.faq', []);
};
export const getFaqAnswers = (state) => {
  return get(state, 'helpAndSupport.faqAnswers', {});
};
export const getOpenTicketList = (state) => {
  const tickets = get(state, 'helpAndSupport.openTickets', []);
  return tickets;
};
export const getClosedTicketList = (state) => {
  const tickets = get(state, 'helpAndSupport.closedTickets', []);
  return tickets;
};
export const getViewMoreValue = (state) => {
  const flag = get(state, 'helpAndSupport.viewMoreFlag', false);
  return flag;
};

const initialState = {
  viewMoreFlag: false,
  selectedTab: 0,
  categories: [],
  subCategories: [],
  faq: [],
  faqAnswers: {},
  closedTickets: [],
  openTickets: [],
};

export default createReducer(initialState, (builder) => {
  builder.addCase(setCategories, (state, action) => {
    state.categories = action.payload;
  });
  builder.addCase(setSubCategories, (state, action) => {
    state.subCategories = action.payload;
  });
  builder.addCase(setFaq, (state, action) => {
    state.faq = action.payload;
  });
  builder.addCase(setFaqAnswers, (state, action) => {
    const newAns = { [action.payload.cms_faq_id]: action.payload };
    const data = { ...state.faqAnswers, ...newAns };
    state.faqAnswers = data;
  });
  builder.addCase(resetFaqAnswers, (state, action) => {
    state.faqAnswers = {};
  });
  builder.addCase(setOpenTickets, (state, action) => {
    state.openTickets = action.payload || [];
  });
  builder.addCase(setClosedTickets, (state, action) => {
    state.closedTickets = action.payload || [];
  });
  builder.addCase(setSelectedTab, (state, action) => {
    state.selectedTab = action.payload;
  });
  builder.addCase(resetTickets, (state, action) => {
    state.openTickets = [];
    state.closedTickets = [];
  });
  builder.addCase(setViewMoreFlag, (state, action) => {
    state.viewMoreFlag = action.payload;
  });
});
